'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _publicPageUrls = require('pricing-pages-unified-ui/utils/publicPageUrls');

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var _partial = require('transmute/partial');

var _partial2 = _interopRequireDefault(_partial);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SIGNUP_BASE_URL = 'https://app.hubspot.com/signup';

var StyledButton = (0, _styledComponents2.default)(_UIButton2.default).withConfig({
  displayName: 'SignupButton__StyledButton'
})(['min-width:200px;height:56px;&&&{display:flex;align-items:center;justify-content:center;line-height:0;}']);

// Not to be confused  with hubs signup url, this is the actual URL
// of the signup app we're sending the user to
function getSignupUrl(signupType) {
  return SIGNUP_BASE_URL + '/' + signupType;
}

var trackClick = function trackClick(sourceId) {
  (0, _getUsageTracker2.default)().track('signupClick', {
    sourceId: sourceId,
    signupType: 'crm' // pass this as a var if we ever support non-CRM signup from pricing pages
  });
};
var SignupButton = function SignupButton(_ref) {
  var sourceId = _ref.sourceId,
      className = _ref.className,
      use = _ref.use,
      ctaKey = _ref.ctaKey,
      signupType = _ref.signupType;

  var hubsSignupUrl = (0, _publicPageUrls.getHubsSignupUrl)({ merchandiseId: _MerchandiseIds.PRODUCT_CRM });
  var hubsSignupCta = sourceId;
  var gaClassName = (0, _publicPageUrls.getGAClassName)(hubsSignupCta);

  var HREF = getSignupUrl(signupType) + '?hubs_signup-url=' + hubsSignupUrl + '&hubs_signup-cta=' + hubsSignupCta;
  return _react2.default.createElement(
    StyledButton,
    {
      use: use,
      href: HREF,
      className: gaClassName + ' ' + className,
      onClick: (0, _partial2.default)(trackClick, sourceId)
    },
    _react2.default.createElement(_FormattedMessage2.default, { message: ctaKey, className: gaClassName })
  );
};

SignupButton.defaultProps = {
  use: 'primary',
  ctaKey: 'pricingPage.signupCtas.getHubSpotCRM',
  signupType: 'crm'
};

SignupButton.propTypes = {
  sourceId: _react.PropTypes.string.isRequired,
  className: _react.PropTypes.string,
  use: _react.PropTypes.string,
  ctaKey: _react.PropTypes.string,
  signupType: _react.PropTypes.oneOf(['crm', 'marketing', 'sales', 'service']).isRequired
};

exports.default = SignupButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/public-only/SignupButton.js
// module id = 362
// module chunks = 3 4